import React, { ReactNode } from 'react';

import { withTrack, WithTrack } from '../../utils/analytics';

export type EmailShareProps = WithTrack & {
  children: ReactNode;
  className?: string;
  subject: string;
  message: string;
  trackingData?: Record<string, any>;
};

export class EmailShare extends React.PureComponent<EmailShareProps> {
  trackClick = () => {
    const { track, trackingData } = this.props;
    track({
      action_name: 'click',
      subtype: 'share',
      event: 'click',
      event_value: 'email',
      ...trackingData,
    });
  };

  render() {
    const { children, className, subject, message } = this.props;

    return (
      <a
        data-qa="email-btn"
        href={`mailto:?subject=${encodeURIComponent(
          subject,
        )}&body=${encodeURIComponent(message)}`}
        onClick={this.trackClick}
        className={`jg-btn jg-btn--email ${className}`}
      >
        {children}
      </a>
    );
  }
}

export default withTrack(EmailShare);
